import { Stack, Box,Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import YouTube from 'react-youtube';
import { fetchFromAPI } from "../utils/fetchFromAPI";
import { Container } from "react-bootstrap";
import {Loader} from "./";


function ShortVideo({currentVideo}) {
    const [videoDetail, setVideoDetail] = useState(null);
    const [ isAlertVisible, setIsAlertVisible ] = useState(false);

      
     
    useEffect(() => {
      const timer = setTimeout(() => {
        console.log('Initial timeout!')
        setIsAlertVisible(false)
      
      }, 100);
    }, []);


    useEffect(()=>{
        if (isAlertVisible && currentVideo){
          // console.log(currentVideo[0].id?.videoId)
          fetchFromAPI(`videos?part=snippet,statistics&id=${currentVideo[0]?.id?.videoId}`)
          .then((data) => {
            setVideoDetail([data.items[0]])
            console.log(data.items[0])
          
          })
        }
        
      },[isAlertVisible])

      if(!currentVideo) return <Loader />;
  return (
    <Stack sx={{borderRadius:"10px",alignItems:"center",justifyContent:"center",width : "300px",height:"480px", backdropFilter:"blur(8px)"}}>
        <Box sx = {{borderRadius:"10px"}}>
            <iframe borderRadius="10px" frameborder="0" width="250px" height="450px" src={'https://www.youtube.com/embed/'+currentVideo[0]?.id?.videoId+"?autoplay=1"} title="YouTube video" allowFullsSreen></iframe>
          </Box>
        
        {/* <YouTube videoId={currentVideo[0]?.id?.videoId} opts={videoOptions} /> */}
        
    </Stack>
  )
}

export default ShortVideo